import { useRef, useState } from 'react'
import { toast } from 'sonner'
import { uploadFileWithProgress } from '@/api/uploadFile'
import { useDeleteFileMutation } from '@/features/editor/uploadsApi'
import { FIELD_LIMITS } from '@/features/editor/constants/fieldLimits'
import { useAppSelector } from '@/store/hooks'
import { uploadErrorText } from '@/api/uploadError'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

interface Args {
  currentImage: string | null
  onChange: (url: string | null) => void
}

export const useCoverUpload = ({ currentImage, onChange }: Args) => {
  const fileRef = useRef<HTMLInputElement>(null)
  // Процент загрузки (`null` — не грузим): полоска и лоадер поверх карточки.
  const [progress, setProgress] = useState<number | null>(null)
  const accessToken = useAppSelector((s) => s.authTokens.accessToken || s.dev.pastedJwt)
  const [deleteFile] = useDeleteFileMutation()

  const openPicker = () => fileRef.current?.click()

  const handleFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (e.target) e.target.value = ''
    if (!file) return
    if (!file.type.startsWith('image/')) {
      toast.error(messagesNow(messages).notAnImage)
      return
    }
    if (file.size > FIELD_LIMITS.UPLOAD_MAX_BYTES) {
      toast.error(messagesNow(messages).fileTooLarge(FIELD_LIMITS.UPLOAD_MAX_MB))
      return
    }
    setProgress(0)
    try {
      const oldUrl = currentImage
      const url = await uploadFileWithProgress({
        file,
        compressionType: 'banner_compression',
        accessToken,
        onProgress: (p) => setProgress(p.percent),
      })
      onChange(url)
      if (oldUrl) deleteFile({ fileUrl: oldUrl }).catch(() => {})
    } catch (err) {
      toast.error(uploadErrorText(err))
    } finally {
      setProgress(null)
    }
  }

  return { fileRef, uploading: progress !== null, progress, openPicker, handleFile }
}
